import {
  Component,
  Event,
  EventEmitter,
  Fragment,
  getAssetPath,
  h,
  Host,
  Prop,
} from '@stencil/core';

import wcShared from '@web-components/shared';

import { INews } from '../../../../models/typing';
import { NewsService } from '../../../../services/news.service';
import newsStore, { TabsType } from '../../../../stores/news.store';

@Component({
  tag: 'item-news',
  styleUrl: 'item-news.scss',
  shadow: true,
})
export class ItemNews {
  @Prop() readonly item: INews;

  @Event() handleNewsEvent: EventEmitter<{ unseenNewsCount: number; toClose: boolean }>;

  private isRecentTab = newsStore.tab === TabsType.Recent;
  private DIVISIONS = [
    { amount: 60, name: 'seconds' },
    { amount: 60, name: 'minutes' },
    { amount: 24, name: 'hours' },
    { amount: 30, name: 'days' },
    { amount: 12, name: 'months' },
    { amount: Number.POSITIVE_INFINITY, name: 'years' },
  ];
  private LABEL_LIST = {
    news: wcShared?.translate('Nouveaute'),
    update: wcShared?.translate('Mise a jour'),
    product: wcShared?.translate('Produit'),
    pinned: wcShared?.translate('A la une'),
  };

  private handleNewsClick() {
    if (!this.item.seen) {
      NewsService.postNews(this.item.id).then((r) => {
        if (r.result === 'success') {
          const recentNewsCopy = [...newsStore.recent];
          const targetIndex = newsStore.recent.findIndex((item) => item.id === this.item.id);
          recentNewsCopy[targetIndex] = {
            ...newsStore.recent[targetIndex],
            seen: !newsStore.recent[targetIndex].seen,
          };
          newsStore.recent = recentNewsCopy;

          this.handleNewsEvent.emit({
            unseenNewsCount: newsStore.unseenNewsCount - 1,
            toClose: this.item.link !== '',
          });
        }
      });
    }

    if (Boolean(this.item.link)) {
      window.open(this.item.link, '_blank', 'noopener,noreferrer');
    }
  }

  private formatTimeAgo() {
    const formatter = new Intl.RelativeTimeFormat(wcShared?.store?.utils?.getLang(), {
      numeric: 'auto',
    });
    const date = new Date(this.item.date * 1000);
    let duration = (date.getTime() - new Date().getTime()) / 1000;

    for (let i = 0; i < this.DIVISIONS.length; i++) {
      const division = this.DIVISIONS[i];
      if (Math.abs(duration) < division.amount) {
        return formatter.format(
          Math.round(duration),
          division.name as 'seconds' | 'minutes' | 'hours' | 'days' | 'months',
        );
      }
      duration /= division.amount;
    }
  }

  // private getMonthDate() {
  //   const date = new Date(this.item.date * 1000);
  //   const lang = wcShared?.store?.utils?.getLang();
  //
  //   return date.toLocaleString(lang + '-' + lang.toUpperCase(), {
  //     month: 'long',
  //     year: 'numeric',
  //   });
  // }

  private isMoreThanOneWeek(): boolean {
    const dateToCompare = new Date(this.item.date * 1000);
    dateToCompare.setDate(dateToCompare.getDate() + 7);
    const today = new Date();

    return today.getTime() > dateToCompare.getTime();
  }

  render() {
    return (
      <Host>
        <div
          class={{
            'item-news': true,
            pointer: (this.item.link !== null && this.item.link !== '') || !this.item.seen,
            'unseen-news': !this.item.seen && this.isRecentTab,
            'pinned-news': this.item.is_pinned,
          }}
          onClick={() => this.handleNewsClick()}
        >
          <div class="item-news__info">
            <div class="label">
              {this.item.is_pinned ? this.LABEL_LIST['pinned'] : this.LABEL_LIST[this.item.label]}
            </div>
            {this.isRecentTab && !this.item.seen && (
              <div>
                {this.item.is_pinned ? (
                  <img
                    src={getAssetPath('./../assets/icons/pinned-star.svg')}
                    alt="pinned news"
                  />
                ) : (
                  <div class="state-icon"></div>
                )}
              </div>
            )}
          </div>

          <div class="item-news__title">
            <div class="service-icon">
              <span class={{ 'unseen-news': !this.item.seen }}>
                <img
                  src={getAssetPath(
                    `./../assets/services-icon/${this.item.service_id_icon ?? 'default'}.svg`,
                  )}
                  alt="service-icon"
                />
              </span>
            </div>
            <div
              class="text"
              innerHTML={this.item.title}
            />
          </div>

          <div
            class="item-news__content"
            innerHTML={this.item.content}
          />

          {this.item.link && (
            <div class="item-news__link">
              <span>{this.item.see_more_link}</span>
            </div>
          )}

          {this.item.image_link && (
            <div class="item-news__image">
              <img
                src={this.item.image_link}
                alt="news-image"
              />
            </div>
          )}

          {this.item.vod_link && (
            <iframe
              class={{
                'item-news__vod': true,
                'item-news__vod--square': this.item.vod_format === '1:1',
              }}
              loading="lazy"
              frameBorder="0"
              src={this.item.vod_link}
              allowFullScreen
            ></iframe>
          )}

          <div class="item-news__date">
            {this.isMoreThanOneWeek() && (
              <Fragment>
                {/* Hide it until we need to use it again */}
                {/*<div class="left-date">{this.getMonthDate().charAt(0).toUpperCase() + this.getMonthDate().slice(1)}</div>*/}
                {/*<div class="bullet"></div>*/}
              </Fragment>
            )}
            {this.isRecentTab && (
              <div class="right-date">
                {this.formatTimeAgo().charAt(0).toUpperCase() + this.formatTimeAgo().slice(1)}
              </div>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
